<template>
  <div class="content">
    <img src="../../assets/img/share/share_top.png" width="100%" />
    <van-tabs
      class="custom-top"
      @click="tabSelect"
      v-model="activeTab"
      title-inactive-color="#ffffff"
      title-active-color="#ffffff"
      :ellipsis="false"
      :swipeable="isSwipeable"
      sticky
      :offset-top="0"
    >
      <van-tab
        v-for="(item, index) in [
          $lang.common_txt27,
          $lang.common_txt28,
          $lang.common_txt29
        ]"
        :key="index"
      >
        <template #title>
          <span class="tab-text" :class="{ active: index === activeTab }">{{
            item
          }}</span>
        </template>
        <div class="content-tab--c">
          <share-ones v-if="index === 0"></share-ones>
          <share-two
            v-if="index === 1"
            @pauseSwipe="pauseSwipe"
            @resumeSwipe="resumeSwipe"
          ></share-two>
          <share-three v-if="index === 2"></share-three>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import ShareOnes from '../../components/share/ShareOnes.vue'
import ShareTwo from '../../components/share/ShareTwo.vue'
import ShareThree from '../../components/share/ShareThree.vue'
export default {
  name: 'share',
  components: { ShareOnes, ShareTwo, ShareThree },
  data() {
    return {
      activeTab: 0,
      isSwipeable: true
    }
  },
  methods: {
    tabSelect() {},
    pauseSwipe() {
      this.isSwipeable = false
    },
    resumeSwipe() {
      this.isSwipeable = true
    }
  }
}
</script>
<style lang="less" scoped>
.custom-top {
  margin-top: -46px;
  ::v-deep .van-tabs__nav--line {
    padding-right: 0;
    padding-left: 0;
    background: rgba(0, 0, 0, 0.5);
    -webkit-backdrop-filter: blur(4px);
    backdrop-filter: blur(4px);
    padding-bottom: 0 !important;
  }
  ::v-deep .van-tabs__wrap--scrollable .van-tab {
    border-bottom: 1px solid @info-color;
  }
  ::v-deep .van-tabs--line .van-tabs__wrap {
    width: 100%;
    margin: 0 auto 10px;
    // border-radius: 12px;
  }
  ::v-deep .van-sticky--fixed {
    background: rgba(0, 0, 0, 0.1);
    -webkit-backdrop-filter: blur(4px);
    backdrop-filter: blur(4px);
  }
  /* 使用深度选择器覆盖原生样式 */
  ::v-deep .van-tabs__line {
    display: none;
  }
  ::v-deep .van-tab__text {
    font-size: var(--vk-fs-xs);
  }
  .active {
    background: #3979e3;
    padding: 10px 10px 14px 10px;
    border-radius: 10px 10px 0 0;
    font-weight: bold;
  }
}
</style>
